// js/auth.js
import { apiFetch } from './api.js';
import { Toast } from '../comun/toast.js';
import { registrarSW } from './sw-registro.js';

registrarSW();

document.addEventListener('DOMContentLoaded', () => {
    const loginForm = document.getElementById('login-form');
    const verifyForm = document.getElementById('verify-form');
    let tempEmail = '';

    // Evento: Envío de credenciales
    loginForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = document.getElementById('btn-login');
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;

        btn.disabled = true;
        btn.innerHTML = '<span class="skeleton-text">Procesando...</span>';

        try {
            await apiFetch('/login', {
                method: 'POST',
                body: JSON.stringify({ email, password })
            });

            // Éxito: Guardar correo temporalmente y cambiar vista
            tempEmail = email;
            loginForm.classList.add('hidden');
            verifyForm.classList.remove('hidden');
            document.getElementById('form-title').innerText = 'Verificación 2FA';
            Toast.success('Código enviado a tu correo');

        } catch (error) {
            // Error ya mostrado por apiFetch (Toast)
            btn.disabled = false;
            btn.innerText = 'Autenticar';
        }
    });

    // Evento: Envío de PIN 2FA
    verifyForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = document.getElementById('btn-verify');
        const codigo = document.getElementById('codigo').value;

        btn.disabled = true;
        btn.innerHTML = '<span class="skeleton-text">Verificando...</span>';

        try {
            const res = await apiFetch('/verify', {
                method: 'POST',
                body: JSON.stringify({ email: tempEmail, codigo })
            });

            // Guardar sesión y redirigir
            localStorage.setItem('admin_token', res.token);
            localStorage.setItem('admin_user', JSON.stringify(res.admin));

            Toast.success('Acceso concedido');
            setTimeout(() => {
                window.location.href = '/dashboard.html';
            }, 1000);

        } catch (error) {
            btn.disabled = false;
            btn.innerText = 'Verificar y Entrar';
        }
    });
});
